import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=64d7183e&scoped=true&"
import script from "./AppLink.vue?vue&type=script&lang=ts&"
export * from "./AppLink.vue?vue&type=script&lang=ts&"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=64d7183e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7183e",
  null
  
)

export default component.exports